var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-content-side-catalog"},[(_vm.show)?_c('side-catalog',_vm._b({staticClass:"catalog",scopedSlots:_vm._u([{key:"default",fn:function({ isActive }){return [_c('i',{class:['line-style', isActive ? 'line-style--active' : '']})]}}],null,false,698825853)},'side-catalog',_vm.catalogProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }